import React from 'react'

import styles from './PageLoading.module.less'
import { SpinLoading } from 'antd-mobile'
import { useTranslation } from 'react-i18next'

export default function PageLoading() {
  const { t } = useTranslation()

  return (
    <div className={styles.container}>
      <SpinLoading style={{ '--size': '32px' }}></SpinLoading>
      <p className={styles.placeholder}>{t('common.mobile.loading')}</p>
    </div>
  )
}
